var EHDI = EHDI || Object.create(null);
var CKM = CKM || Object.create(null);
var UTILS = UTILS || Object.create(null);
var POOLS = POOLS || Object.create(null);

CKM.CakeSlot  = function() 
{
    EHDI.aka.Container.call(this);
    var CAKE_THICKNESS = 7;
   

    var _me = this;
    var _stackLimit;
    var _stack = [];
    var _topCake;
    var _typedCake = 0;

    var  _init = function(stackLimit)
    {
        _initProps(stackLimit);
        _initGraphics();
        _initListener();
    }

    var _dispose = function()
    {
        _killListener();
        _killGraphics();
        _killProps();
    }


    //Initialization
    var _initProps = function(stackLimit)
    {
        if(typeof stackLimit !== 'number')
            _stackLimit = 0;
        else
            _stackLimit = stackLimit;
    }

    var _initGraphics = function()
    {        
    }

    var _initListener = function()
    {
        _me.on('click', _me.tap);
        _me.interactive = true;
    }

    //Disposal
    var _killListener = function()
    {
        _me.off('click', _me.tap);
        _me.interactive = false;
    }
    var _killGraphics = function()
    {
        _me.removeChildren();
    }
    var _killProps = function()
    {
        while(_stack.length > 0)
        {
            var cake = _stack.pop();
            cake.dispose();
        }
        _topCake = null;
        
    }


    var _stackPush = function(pushCake, forcedPush)
    {
        if(_stack.length >= _stackLimit) {
            console.log(_stack.length, _stackLimit);
            return false;
        }

        if(!forcedPush)
            if(!_checkTypes(pushCake.type))
                return false;

        _topCake = pushCake;
        var posOffset = _stack.length * CAKE_THICKNESS * -1;
            pushCake.x = posOffset;
            pushCake.y = posOffset;    
        _stack.push(pushCake);
        _me.addChild(pushCake);
        _typedCake++;
        return true;
    }

    var _stackPop = function()
    {
        var popCake = _stack.pop();
        popCake.dim();

        _topCake = _stack[_stack.length - 1];
        _me.removeChild(popCake);
        
        _stackLimit--;
        _typedCake--;
        if(_stackLimit <= 0)
            _stackLimit = 0;

        if(_typedCake <= 0)
            _typedCake = 0;

        return popCake;
    }

    var _stackReset = function()
    {
        // _me.removeChildren();
        while(_stack.length > 0)
        {
            var cake = _stack.pop();
            cake.dim();
            _me.removeChild(cake);
            cake = null;
        }
        _typedCake = 0;
        _stack = [];
        _topCake = null;
    }
    
    var _flushCakes = function() {
        var types = [];
        while(_stack.length > 0)
        {
            var cake = _stack.pop();
            console.log(cake);
            types.push(cake);
            cake.dim();
            _me.removeChild(cake);
        }
        console.log(_stack.length);
        _typedCake = 0;
        return types;
    }

    var _stackClearType = function()
    {
        var types = [];

        for(var c = 0, cLim = _stack.length; c<cLim; c++)
        {
            var cake = _stack[c];
            // cake.updateType(-1);
            types.push(cake.type);
        }
        _typedCake = 0;
        return types;
    }
    
    var _updateTopCakeType = function(type)
    {

        _topCake.updateType(type);

    }

    var _updateCakeType = function(type, forcedPush)
    {

        if(_typedCake >= _stack.length)
            return false;
        
        // if(!forcedPush)
        //     if(!_checkTypes(type))
        //         return false;

        if(_stack[_typedCake].updateType(type))
        {
            _typedCake++;
            return true;
        }

        return false;

    }

    var _tap = function()
    {
        if(CKM.gameInstance.checkVacantNeighbor(_me))
        {
            _topCake.glow();            
            EHDI.GAME.soundManager.playSFX("select");
            CKM.gameInstance.matchCake(_me);
        }
        else
        {
            EHDI.GAME.soundManager.playSFX("wrong");
            _topCake.shake();
        }
    }

    var _untap = function()
    {
        _topCake.dim();
    }

    var _checkTypes = function(type)
    {
        if(_stack && _stack.length >0)
        {
            for(var i = 0, l = _stack.length; i<l; i++)
            {
                if(type == _stack[i].type)
                    return false;
            }
        }

        return true;
    }
    
    var _capStack = function() {
        _stackLimit = _stack.length;
    }


    this.tap = _tap.bind(this);
    this.untap = _untap.bind(this);
    this.init = _init.bind(this);
    this.resizeCakeSlot = _initProps.bind(this);
    this.emptyCakeSlot = _flushCakes.bind(this);
    this.capStack = _capStack.bind(this);
    this.dispose = _dispose.bind(this);
    this.push = _stackPush.bind(this);
    this.pop = _stackPop.bind(this);
    this.reset = _stackReset.bind(this);
    this.stackClearType = _stackClearType.bind(this);
    this.updateCakeType = _updateCakeType.bind(this);
    this.updateTopCakeType = _updateTopCakeType.bind(this);

    Object.defineProperties( _me, {
        "stackSize":{
            get: function() {return _stack.length;},
            enumerable: true

        },
        "stackLimit":{
            get: function() {return _stackLimit;},
            enumerable: true
        },
        "isFull":{
            get: function() {return (_stack.length >= _stackLimit);},
            enumerable: true
        },
        "topCakeType":{
            get: function() {

                if(!_topCake)
                    return -1;
                else
                    return _topCake.type;
            },
            enumerable: true
        },
        "effectPtX":{
            get: function() {if(_stack.length > 0) return this.x +_topCake.x + 24;
                                else return this.x +24; },
            enumerable: true
        },
        "effectPtY":{
            get: function() {if(_stack.length > 0) return this.y+_topCake.y +32;
                                else return this.y + 32;},
            enumerable: true
        },
        // "isCaged": {
        //     get: function () { return _isCaged; },
        //     set: function ( p_value ) { if ( _isCaged !== p_value  ) _isCaged = p_value; },
        //     enumerable: true
        // }
    });

    return _me;
}
CKM.CakeSlot.prototype = Object.create(EHDI.aka.Container.prototype);


POOLS.slotPool = new Pool(CKM.CakeSlot, 100); 